import { Link, Stack, Typography } from '@mui/material';
import { ReactComponent as Triangle } from '../assets/svg/pinkTriangle.svg';
import { KeyedObject } from 'types';

const ErrorMsg = (props: KeyedObject) => {
    const { label, onPress, linkText, triangleStyles } = props;
    return (
        <>
            <Stack sx={{ marginTop: '8px', width: '90%', ...triangleStyles }}>
                <Triangle />
            </Stack>
            <Typography
                component="span"
                sx={{
                    background: '#FAE7ED',
                    marginTop: '-4px',
                    color: '#D11149',
                    textAlign: 'left',
                    padding: '14px',
                    fontSize: '12px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    width: '100%',
                    display: 'inherit'
                }}
            >
                {label} {'  '}
                {linkText && (
                    <Link
                        component="button"
                        onClick={onPress}
                        underline="hover"
                        sx={{ color: '#002443', cursor: 'pointer !important', textDecoration: 'none', marginLeft: '5px' }}
                    >
                        {'  '} {linkText}
                    </Link>
                )}
            </Typography>
        </>
    );
};

export default ErrorMsg;
